import { render, staticRenderFns } from "./SectionStatics.component.vue?vue&type=template&id=32043012&"
import script from "./SectionStatics.component.vue?vue&type=script&lang=js&"
export * from "./SectionStatics.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports